import { render, staticRenderFns } from "./EstimatedDeliveryDate.vue?vue&type=template&id=20092e73"
import script from "./EstimatedDeliveryDate.vue?vue&type=script&lang=js"
export * from "./EstimatedDeliveryDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DeliveredFromDate: require('/app/components/DeliveredFromDate.vue').default})
